import { render, staticRenderFns } from "./PolicyMain.vue?vue&type=template&id=3d135680&"
import script from "./PolicyMain.vue?vue&type=script&lang=js&"
export * from "./PolicyMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports